import { put, takeLatest, call } from "redux-saga/effects";
import { setListPermission, getListPermissionAsync } from "./permission.slice";
import { message } from "antd";
import api from "service/apiService";
import { translate } from "utils";

// Get list
function* getListPermissionSaga() {
	const { response, error } = yield call(async () => {
		try {
			const response = await api.get("/permission", {});
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		yield put({ type: setListPermission.type, payload: response });
	} else {
		message.error(translate(error.message));
	}
}
function* watchGetListPermission() {
	yield takeLatest(getListPermissionAsync, getListPermissionSaga);
}

const customerSaga = [watchGetListPermission()];
export default customerSaga;
